import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

// Cliente Supabase básico (sin autenticación)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  }
})

// Función para crear cliente Supabase con Third-Party Auth (Clerk) mejorado
export function createClerkSupabaseClient(session) {
  return createClient(supabaseUrl, supabaseAnonKey, {
    accessToken: async () => {
      try {
        // Usar template específico para Supabase con mejor manejo de errores
        const token = await session?.getToken({ template: 'supabase' })
        
        // Validar que el token existe y no está expirado
        if (!token) {
          console.warn('No token available from Clerk session')
          return null
        }

        // Validación básica del token sin verificar signature (solo estructura)
        try {
          const payload = JSON.parse(atob(token.split('.')[1]))
          const now = Date.now() / 1000
          
          if (payload.exp && payload.exp < now) {
            console.warn('Token expired, requesting fresh token')
            // Intentar obtener un token fresco
            return await session?.getToken({ template: 'supabase', skipCache: true })
          }
        } catch (parseError) {
          console.warn('Error parsing token payload:', parseError)
        }
        
        return token
      } catch (error) {
        console.error('Error getting Clerk token for Supabase:', error)
        
        // En caso de error crítico, redirigir solo si estamos en el browser
        if (typeof window !== 'undefined' && error.message.includes('unauthorized')) {
          window.location.href = '/sign-in'
        }
        
        return null
      }
    },
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    }
  })
}

export default supabase